import S3FileUpload from "react-s3/lib/ReactS3";
import Config from "./Config";

export const UploadImage = async (img) => {
  let url = await S3FileUpload.uploadFile(img, Config()).then(
    (res) => res.location
  );

  return url;
};
